export const calculateArea = (coords: [number, number][]): number => {
    if (coords.length < 3) return 0;

    const earthRadius = 6378137; // meters
    let area = 0;

    for (let i = 0; i < coords.length; i++) {
        const j = (i + 1) % coords.length;
        const lat1 = coords[i][0] * (Math.PI / 180);
        const lng1 = coords[i][1] * (Math.PI / 180);
        const lat2 = coords[j][0] * (Math.PI / 180);
        const lng2 = coords[j][1] * (Math.PI / 180);

        area += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2));
    }

    area = Math.abs(area * earthRadius * earthRadius / 2);
    return area / 10000; // Convert sq meters to hectares
};

export const getCentroid = (coords: [number, number][]): [number, number] | null => {
    if (coords.length === 0) return null;

    let latSum = 0;
    let lngSum = 0;

    coords.forEach(coord => {
        latSum += coord[0];
        lngSum += coord[1];
    });

    return [latSum / coords.length, lngSum / coords.length];
};

export const RWANDA_DEFAULTS = {
    center: {
        lat: -1.9441,
        lng: 30.0619, // Kigali
    },
    zoom: 9
};

export const validateRwandaCoordinates = (lat: number, lng: number): boolean => {
    return lat >= -2.9 && lat <= -1.0 && lng >= 28.8 && lng <= 30.9;
};

export const calculateCenter = (coords: { lat: number; lng: number }[]): { lat: number; lng: number } => {
    if (coords.length === 0) return RWANDA_DEFAULTS.center;

    let latSum = 0;
    let lngSum = 0;

    coords.forEach(coord => {
        latSum += coord.lat;
        lngSum += coord.lng;
    });

    return {
        lat: latSum / coords.length,
        lng: lngSum / coords.length
    };
};

export const getFacilityColor = (type: string): string => {
    switch (type) {
        case 'cold_room':
            return '#00A1DE'; // Brand Blue
        case 'insulated_shed':
            return '#F59E0B'; // Amber
        case 'ambient_storage':
            return '#10B981'; // Green
        default:
            return '#6B7280'; // Gray
    }
};
